import { Assets, Container, Sprite, Texture } from "pixi.js";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SpinnableReelsBigCanvas } from "../SpinAnimation/SpinnableReelsBigCanvas";
import { Rect, Safe, Scale, Size } from "../../MyHelpers";
import { PlayWindow } from "../../api";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { Settings } from "../../Settings";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IBone, ISkeleton, ISkeletonData, ITrackEntry, Spine, TransformMode, IAnimationStateListener } from "pixi-spine";
import { MultiBonusMapSymbol } from "./FamilyMultiBonusConstructiveFeature";
import { AudioManager, ITrack, Track } from "../../AudioManager";


export const symbolCollectMultibonus: string[] = [
    "SRAD",
    "SRAM",
    "SRAJ",
]

export interface PotEndPosition {
    x: number,
    y: number,
}
export interface PotCollectPosition {
    name: string;
    position: PotEndPosition;
}

export class CollectSRAPathFillingPotElement implements Resourceful {
    protected size: Size = null;
    protected position: Rect = null;
    protected skeletonMap: Map<string, ISkeletonData> = null;
    protected spineMap: Map<string, {spine : Spine , listener : IAnimationStateListener}> = new Map<string, {spine : Spine , listener : IAnimationStateListener}>();
    protected symbolSRAToShow : string = "";
    protected potCollectPosition : PotCollectPosition [] = [];
    protected track : ITrack;
    protected gameName : string = null;
    constructor(size: Size, position: Rect, skeletonMap: Map<string, ISkeletonData>, track : ITrack  , gameName : string )  {
        this.size = size;
        this.position = position;
        this.skeletonMap = skeletonMap;
        this.track = track;
        this.gameName = gameName
    }
    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {

    }
    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {

    }
    protected view: Container = null;

    public CreateElement() {
        this.view = new Container();
        this.view.visible = false;
        this.view.name = "CollectSRAPathFillingPot-Container";
        for (let symbolSRA of symbolCollectMultibonus) {
            let spine: Spine = new Spine(this.skeletonMap.get(symbolSRA));
            spine.name = symbolSRA + "-CollectSRAPathFillingPotElement-" + this.gameName;
            //spine.pivot.set(spine.height/2,spine.width/2);  
            const scalePercentage = 1
            const scaleWidth = (this.size.Width / 600) * scalePercentage;
            const scaleHeight = (this.size.Height / 500) * scalePercentage;
            const scaleProm = (scaleHeight + scaleWidth) / 2;
            spine.scale.set(scaleProm);

            this.view.addChild(spine);
            //serch bone 
            // let ikConstraint = spine.skeleton.findBone("target");
            // // //use normal transfor for dont change the path direction 
            // // ikConstraint.data.transformMode = TransformMode.Normal;
            // //updateBone
            // ikConstraint.data.x = ((this.position.centerx - Scale.X(this.potCollectPosition.find(ele=>ele.name == symbolSRA).position.x)) * -1) / scaleProm;
            // ikConstraint.data.y = ((this.position.centery - Scale.Y((this.potCollectPosition.find(ele=>ele.name == symbolSRA).position.y)))) / scaleProm;

            // //update bone into spine 
            // spine.updateTransform();
            // spine.skeleton.updateWorldTransform();
            // spine.skeleton.setBonesToSetupPose();

            spine.visible = false;
            spine.renderable = false;
            //ikConstraint = null;

            let spineCompleteListener = {
                complete: this.AnimComplete,
            };

            spine.state.addListener(spineCompleteListener);
            //    spine?.state?.addListener({
            //         //event: this.eventSpine,
            //         complete: this.AnimComplete,
            //         //start: this.StartAnim
            //     });
            this.spineMap.set(symbolSRA, { spine: spine, listener: spineCompleteListener });

        }
        //this.texture.visible = false;

        this.view.position.x = this.position.centerx;
        this.view.position.y = this.position.centery;
    }

    public UpdateTargets(potCollectPosition: PotCollectPosition [])
    {
        this.potCollectPosition = potCollectPosition;

        for (let symbolSRA of symbolCollectMultibonus) {
            const spine = this.spineMap.get(symbolSRA)?.spine;
            if (!spine) continue;

            let targetIKConstrains = spine.skeleton.findBone("target");
            if (!targetIKConstrains) continue;

            const currentPosition =this.potCollectPosition.find(ele=>ele.name == symbolSRA);

            const scalePercentage = 1
            const scaleWidth = (this.size.Width / 600) * scalePercentage;
            const scaleHeight = (this.size.Height / 500) * scalePercentage;
            const scaleProm = (scaleHeight + scaleWidth) / 2;

            //updateBone
            targetIKConstrains.data.x = ((this.position.centerx - (currentPosition.position.x)) * -1) / scaleProm;
            targetIKConstrains.data.y = ((this.position.centery - ((currentPosition.position.y)))) / scaleProm;

            //update bone into spine 
            spine.updateTransform();
            spine.skeleton.updateWorldTransform();
            spine.skeleton.setBonesToSetupPose();
        }
    }

    protected AnimComplete = (trackComplete: ITrackEntry) => {
        this.view.visible = false;
        this.spineMap.get(this.symbolSRAToShow).spine.renderable = false;
        this.spineMap.get(this.symbolSRAToShow).spine.visible = false;
        this.OnCallBackAnimElementFinished?.(this.symbolSRAToShow);
    }

    // protected getRandomTint(): number {
    //     return Math.floor(Math.random() * 0xFFFFFF);
    // }

    public ViewPIXIAPP() {
        return this.view;
    }
    public Destroy() {
        this.view.visible = false;
        this.spineMap.forEach(ele => {

            ele.spine.visible = false;
            ele?.spine.state?.setEmptyAnimation(0, 0);
            ele?.spine.state?.clearTracks();
            ele?.spine.removeAllListeners();
            ele?.spine.removeFromParent();
            ele?.spine.skeleton?.setToSetupPose();
            if (ele.listener) {
                ele.spine.state?.removeListener(ele.listener);
            }
            ele?.spine.destroy({ children: true, texture: false, baseTexture: true });
            ele = null;
        });
        this.view.removeFromParent();
        this.view.destroy({ children: true, texture: true, baseTexture: true });
        this.view = null;
        this.spineMap.clear();
    }

    public StartAnim(symbolSRAToShow: string) {
        this.view.visible = true;

        const spine = this.spineMap.get(symbolSRAToShow).spine;
        spine.renderable = true;
        spine.visible = true;
        const anim = spine.state?.setAnimation(0, "pathCollect", false);
        // anim.timeScale = 0.1;
        this.symbolSRAToShow = symbolSRAToShow;
    }

    public OnCallBackAnimElementFinished: OnCallBackAnimElementFinished = null;
}

export class CollectSRAPathFillingPot implements Resourceful {
    protected spinnableReels: SpinnableReelsBigCanvas = null;
    protected playWindow: PlayWindow;
    protected gameName: string;
    protected resid: ResourceIdentifier = null;
    protected audio : AudioManager = null;
    constructor(spinnableReels: SpinnableReelsBigCanvas, playWindow: PlayWindow, gameName: string, resid: ResourceIdentifier, audio : AudioManager) {
        this.spinnableReels = spinnableReels;
        this.playWindow = playWindow;
        this.gameName = gameName
        this.resid = resid.Add("CollecSRAPathFillingPot");
        this.audio = audio;
    }
    

    protected potCollectPosition: PotCollectPosition [] = [];
    public UpdateTargets(potCollectPosition: PotCollectPosition[])
    {
        console.log("UpdateTargets: " + JSON.stringify(potCollectPosition));

        this.potCollectPosition = potCollectPosition;
        for (let indexReel = 0; indexReel < this.playWindow.Width; indexReel++) {
            for (let indexRow = 0; indexRow < this.playWindow.Height; indexRow++) {
                const ele = this.elementCollectSRA?.[indexReel]?.[indexRow];

                if (!ele)
                    continue;

                ele.UpdateTargets(this.potCollectPosition);
            }
        }
    }

    public UpdateTargetsGlobal(potCollectPosition: PotCollectPosition[])
    {
        console.log("UpdateTargetsGlobal: " + JSON.stringify(potCollectPosition));
        let localPotCollectPosition: PotCollectPosition[] = potCollectPosition.map(p => {
            
            const local = this.view.toLocal(p.position);

            return {
                name: p.name,
                position: {
                    x: local.x,
                    y: local.y,
                }
            }
        });

        this.UpdateTargets(localPotCollectPosition);
    }

    public GetTargets(): PotCollectPosition[] {
        return this.potCollectPosition;
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {        
        for (let symbolSRA of symbolCollectMultibonus) {
            resourceManager.Add(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/FillingPotFeature/CollectPathSymbol/Symbol_${symbolSRA}_PathCollect.json`, this.resid.ScopedResourceName(`CollectPathSymbol-${symbolSRA}-json`)));
            resourceManager.Add(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/FillingPotFeature/CollectPathSymbol/Symbol_${symbolSRA}_PathCollect.atlas`, this.resid.ScopedResourceName(`CollectPathSymbol-${symbolSRA}-atlas`)));
        }
        this.audio.AddTrack(new Track(`${Settings.ResourcesFolder}multigame/slot/common/resources/tracks/collecSRAPathFillingPot` + Settings.audioFormat, this.resid.ScopedResourceName("collecSRAPathFillingPot")));
    }
    protected elementCollectSRA: CollectSRAPathFillingPotElement[][] = [];
    protected skeletonMap: Map<string, ISkeletonData> = new Map<string, ISkeletonData>();

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        this.skeletonMap = new Map<string, ISkeletonData>();

        for (let symbolSRA of symbolCollectMultibonus) {
            let symbolJsonResource = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`CollectPathSymbol-${symbolSRA}-json`));
            let pixiAssetSymbol = await Assets.load(symbolJsonResource.path).finally(() => {
                //Assets.unload(symbolJsonResource.path);
                Assets.cache.remove(symbolJsonResource.path);

            });

            this.skeletonMap.set(symbolSRA, pixiAssetSymbol.spineData as ISkeletonData);
        }

        for (let indexReel = 0; indexReel < this.playWindow.Width; indexReel++) {
            this.elementCollectSRA.push([])
            for (let indexRow = 0; indexRow < this.playWindow.Height; indexRow++) {
                let ele = new CollectSRAPathFillingPotElement(this.spinnableReels.GetSymbolSize(), this.spinnableReels.GetSymbolRect(indexReel, indexRow) , this.skeletonMap, null , this.gameName);
                ele.UpdateTargets(this.potCollectPosition);
                ele.OnCallBackAnimElementFinished = (nameSraFinished : string )=>{
                    this.OnCallBackFeatureFinished?.(nameSraFinished);
                }
                this.elementCollectSRA[indexReel].push(ele);
                ele = null;
            }
        }
    }
    protected view: Container = null;
    public CreateViewPIXIAPP(spineFillingPot: Spine) {
        this.InitDataPosition(spineFillingPot?.skeleton)
        this.view = new Container();
        this.view.name = "CollectPathFillingPot";
        this.view.visible = false;
        for (let reelElements of this.elementCollectSRA) {
            for (let ele of reelElements) {
                ele.UpdateTargets(this.potCollectPosition);
                ele.CreateElement()
                this.view.addChild(ele.ViewPIXIAPP());
            }
        }
    }

    protected InitDataPosition(skeleton: ISkeleton) {
        if (this.potCollectPosition.length > 0) return
        for (let sra of symbolCollectMultibonus) {
            let bone = skeleton?.findBone(`${MultiBonusMapSymbol[sra]}PlaceHolder`);
            //console.log(`bonePosition-${MultiBonusMapSymbol[sra]}`, bone);
            this.potCollectPosition.push({
                name: sra,
                position: {
                    x: bone.matrix.tx,
                    y: bone.matrix.ty,
                }
            })
        }
        console.log(`${this.gameName}-PositonBone`, this.potCollectPosition)
    }
    public ViewPIXIAPP() {
        return this.view
    }

    public DestroyPIXIAPP() {
        this.view.visible = false;
        for (let reelElements of this.elementCollectSRA) {
            for (let ele of reelElements) {
                ele.Destroy();
            }
        }
        this.view.removeFromParent();
        this.view.destroy({ children: true, baseTexture: true, texture: true });
        this.view = null;
    }

    public ShowSRAAnim(reelIndex: number, rowIndex: number, symbolSRAToShow: string) {
        this.view.visible = true;
        const sraToShow = symbolCollectMultibonus.find((ele) => ele == symbolSRAToShow)
        if (sraToShow) {
            this.elementCollectSRA[reelIndex][rowIndex].StartAnim(symbolSRAToShow);
        }
        // if(symbolCollectMultibonus.find((ele)=>ele == symbolSRAToShow)) this.elementCollectSRA[reelIndex][rowIndex].StartAnim(symbolSRAToShow);
        this.audio.Play(this.resid.ScopedResourceName("collecSRAPathFillingPot"), false);
    }

    public OnResize(): void {

        if (!this.view) {
            return;
        }
        this.SetToDefault();

        const scaleX = Scale.W(1920) / 1920;
        const scaleY = Scale.H(1080) / 1080;
        const scale = Math.min(scaleX, scaleY)

        this.view.scale.set(scale);
        

    }

    private SetToDefault(): void {

    }

    public OnCallBackFeatureFinished: OnCallBackFeatureFinished = null;
}

export type OnCallBackAnimElementFinished = (nameSRAFinished: string) => void;
export type OnCallBackFeatureFinished = (nameSRAFinished: string) => void;
